<script setup>
  import { computed, onUnmounted } from 'vue';
  import SpotListRow from '@/components/SpotListRow.vue';
  import BannerAd from '@/components/BannerAd.vue'

  const props = defineProps({
    data: {
      type: Object,
      default: null
    },
    showObsGraph: {
      type: Boolean,
      default: true
    },
    showForecastGraph: {
      type: Boolean,
      default: true
    },
    showDistance: {
      type: Boolean,
      default: false
    },
    showLinkIcon: {
      type: Boolean,
      default: true
    },
    showLocalTimestamp: {
      type: Boolean,
      default: true
    },
    showModelData: {
      type: Boolean,
      default: false
    },
    sort: {
      type: String,
      default: 'distance'
    },
    adIndexes: {
      type: Array,
      default: () => []
    },
  });

  const rowLoaders = new Map();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      rowLoaders.get(entry.target)?.();
      observer.unobserve(entry.target);
      rowLoaders.delete(entry.target);
    });
  }, { threshold: 0.1, rootMargin: '300px' });

  const rows = computed(() => {
    const rows = [];
    const adSet = new Set(props.adIndexes);
    let adsPlacedCount = 0;

    for (let i = 0; i < props.data.length; i++) {
      const spot = props.data[i];

      if (adSet.has(i)) {
        rows.push({ type: 'ad', index: adsPlacedCount, id: `ad-${adsPlacedCount++}` });
      }

      rows.push({ type: 'spot', index: i, id: spot.id })
    }

    return rows;
  })

  const registerRow = ({ el, loadGraphs }) => {
    if (!el) return;
    rowLoaders.set(el, loadGraphs);
    observer.observe(el);
  };

  const unregisterRow = (el) => {
    if (!el) return;
    observer.unobserve(el);
    rowLoaders.delete(el);
  };

  onUnmounted(() => observer.disconnect());

</script>

<template>
  <div class="jwx-spot-list-container">
    <p v-if="data.length === 0" class="jwx-spot-list-message">No weather stations found.</p>

    <div v-else>
      <ul class="jwx-spot-list">
        <li
          v-for="row in rows"
          class="jwx-spot-list__item"
          :key="row.id"
        >
          <SpotListRow
            v-if="row.type === 'spot'"
            :spot="props.data[row.index]"
            :showLocalTimestamp="props.showLocalTimestamp"
            :showDistance="props.showDistance"
            @register="registerRow"
            @unregister="unregisterRow"
          />
          <BannerAd
            v-else
            type="mid"
          />
        </li>

      </ul>
    </div>
  </div>
</template>
